import {
  FlowBlockValueNumberSchema,
  FlowFormSetSearchScope,
  FlowGetFormSetType,
} from 'flow-schema';
import { z } from 'zod';

export const getFormSetLimitNumberSchema = z.number().int().min(1).max(50);

export const getFormSetBlockAutomaticallyAppliedAllLimitSchema = FlowBlockValueNumberSchema({
  numberValidationSchema: getFormSetLimitNumberSchema,
})
  .optional()
  .default('10');

const baseConfig = z.object({
  formTemplateId: z.string().optional(),
  primitive: z.string().optional(),
});

export const GetFormSetBlockConfigSchema = z.discriminatedUnion('type', [
  baseConfig.extend({
    type: z.literal(FlowGetFormSetType.UserDefined),
    formSetId: z.string(),
  }),
  baseConfig.extend({
    type: z.literal(FlowGetFormSetType.AutomaticallyApplied),
    searchScope: z
      .enum(FlowFormSetSearchScope)
      .optional()
      .default(FlowFormSetSearchScope.CurrentPractice),
  }),
  baseConfig.extend({
    type: z.literal(FlowGetFormSetType.AutomaticallyAppliedAll),
    searchScope: z
      .enum(FlowFormSetSearchScope)
      .optional()
      .default(FlowFormSetSearchScope.CurrentPractice),
    before: z.string().optional(),
    after: z.string().optional(),
    limit: getFormSetBlockAutomaticallyAppliedAllLimitSchema,
  }),
]);

export type GetFormSetBlockConfig = z.infer<typeof GetFormSetBlockConfigSchema>;
